/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

import liveSearchCatalog from './catalogsearch/catalog/index'
import liveSearchContext from './catalogsearch/context/index'
import liveSearchFacets from './catalogsearch/facets/index'
import liveSearchHelper from './catalogsearch/helper/index'
import liveSearchProducts from './catalogsearch/products/index'
import liveSearchSort from './catalogsearch/sort/index'
import liveSearchUrl from './catalogsearch/url/index'
import liveSearchDataLayer from './catalogsearch/datalayer'
import meySwatchRow from './catalogsearch/products/swatches'

document.addEventListener('alpine:init', () => {
    Alpine.data('meySwatchRow', meySwatchRow)
    Alpine.data('catalogSearch', function() {
        return {
            ...window.liveSearchConfig,
            ...liveSearchCatalog,
            ...liveSearchContext,
            ...liveSearchFacets,
            ...liveSearchHelper,
            ...liveSearchProducts,
            ...liveSearchSort,
            ...liveSearchUrl,
            ...liveSearchDataLayer,
            hasSeoIndexedFilters: Object.keys(window.liveSearchConfig.seoIndexedFilters || {}).length > 0,
            // Store properties in local storage
            facets: Alpine.$persist([]).as('liveSearchFacets'),
            clickedProductSelector: Alpine.$persist('').as('liveSearchClickedProductSelector'),
            clickedProductPage: Alpine.$persist(1).as('liveSearchClickedProductPage'),
            selectedSortOptionParams: Alpine.$persist({}).as('liveSearchSelectedSortOptionParams'),
            // Store selected facets and last visited category path in session storage
            selectedFacets: Alpine.$persist([]).using(sessionStorage).as('liveSearchSelectedFacets'),
            lastVisitedCategoryPath: Alpine.$persist('').using(sessionStorage).as('liveSearchLastVisitedCategoryPath'),
            filtersExpanded: liveSearchHelper.getInitialFiltersExpandedState(),
            storeDetails: {
                storefrontInstanceId: this.contextInstanceId,
                environmentId: this.environmentId,
                websiteCode: this.websiteCode,
                storeCode: this.storeCode,
                storeViewCode: this.storeViewCode
            },
            pageType: window.liveSearchConfig.view === 'catalog' ? 'category' : 'search',
            init() {
                this.checkViewPort()
                this.initCatalog()
                this.initSort()
            }
        }
    })
})
